import(/* webpackMode: "eager" */ "/var/www/coco-app-platform/app/[locale]/error.tsx");
